import { render, staticRenderFns } from "./CropCoverImage.vue?vue&type=template&id=202aa96c&scoped=true&"
import script from "./CropCoverImage.vue?vue&type=script&lang=js&"
export * from "./CropCoverImage.vue?vue&type=script&lang=js&"
import style0 from "./CropCoverImage.vue?vue&type=style&index=0&id=202aa96c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202aa96c",
  null
  
)

export default component.exports